import {JSX} from 'react';
import {getI18n} from 'react-i18next';
import {useParams} from 'react-router-dom';

import {HealthReportWrapper} from '@/components/business/analytics/health-report/health-report-wrapper';
import LoadingView from '@/components/static/loading-view';
import {Page} from '@/decorators/page';
import {HealthReportDashboardTypeEnum} from '@/enum/health-report-dashboard-type-enum';
import {usePatientData} from '@/hooks/backend/use-patient-data';
import {GlobalContext, PatientContextService} from '@/services/patient-context-service';

import { HealthReportLastAvailableNightRealtime } from './health-report-last-available-night-realtime';
import { HealthReportLastAvailableNightSpot } from './health-report-last-available-night-spot';

function wrapWithPage(Component: JSX.ElementType) {
    const isGabi = PatientContextService.getGlobalContext() === GlobalContext.GABI;
    const nameFn = (props: { [key: string]: unknown }) => {
        const t = getI18n().t;
        return isGabi ?
            t('healthReport.lastnight.title', {N: props.nbDays}) :
            t('healthReport.lastday.title', {N: props.nbDays});
    };
    return Page({
        name: nameFn,
        pagePath: () => ([
            {
                route: 'patients',
                name: 'Patients'
            },
        ]),
    })(Component);
}

type HealthReportLastAvailableNightPageProps = {
    params: {
        id_patient: string;
    },
    className: string,
};

function HealthReportLastAvailableNightPage_(props: HealthReportLastAvailableNightPageProps) {
    const params: Readonly<Partial<{
        id_patient: string;
    }>> = useParams();
    const patientId = params.id_patient ?? '';

    const [patientDataLoading, patientData] = usePatientData({
        patientId: patientId,
        memoize: true,
    });

    const loading = (
        (patientDataLoading || !patientData)
    );

    if (loading) {
        return (
            <HealthReportWrapper
                patientId={patientId}
                patientData={patientData}
                activeDashboard={HealthReportDashboardTypeEnum.LAST_24H}
            >
                <LoadingView />
            </HealthReportWrapper>
        );
    }
    //--------------------------------------------------------------------------------------------------------------

    const patientContext = PatientContextService.getPatientContext(patientData);
    if (patientContext.hasRealTimeMonitoring) {
        return (
            <HealthReportLastAvailableNightRealtime id_patient={patientId} className={props.className} />
        );
    }
    else {
        return (
            <HealthReportLastAvailableNightSpot id_patient={patientId} className={props.className} />
        );
    }
}

const HealthReportLastAvailableNightPage = wrapWithPage(HealthReportLastAvailableNightPage_);

export {HealthReportLastAvailableNightPage};
